angular.module('filters').filter('reportFilterValue', ["$filter", function($filter) {
  return function(filter, reports) {
    var multiplier, period, ref, ref1, report, withOperator;
    withOperator = function(value) {
      return `${filter.operator_label} ${value}`;
    };
    if (filter.relative_date && ((ref = filter.operator) !== 'IS BLANK' && ref !== 'IS NOT BLANK')) {
      period = $filter('singularize')(filter.period);
      multiplier = $filter('humanize')(filter.multiplier);
      return withOperator(`${filter.number} ${period}(s) ${multiplier}`);
    } else {
      switch (false) {
        case (ref1 = filter.operator) !== 'IN REPORT' && ref1 !== 'NOT IN REPORT':
          report = _.find(reports, function(item) {
            return item.id === +filter.user_value;
          });
          if (report) {
            return withOperator(report.name);
          } else {
            return `${filter.operator_label.replace(' report', '')} [report deleted]`;
          }
          break;
        case filter.data_type !== 'month':
          return withOperator($filter('month')(filter.user_value));
        default:
          return withOperator(filter.user_value);
      }
    }
  };
}]);
